import type { UseFormGetValues } from 'react-hook-form';

import type { SchemaCreditRequestForm } from '../NewCreditRequest/schemas/creditRequestForm.schema';
import { getTotalFinancedAmount } from '../NewCreditRequest/RefinancePlanner/utils/getTotalFinancedAmount';

type Props = {
    getValues: UseFormGetValues<SchemaCreditRequestForm>;
    coApplicantHidden: boolean;
};

export const buildOfferRequestConditionsPayload = ({ getValues, coApplicantHidden }: Props) => {
    const dispositionsKredite = getValues('dispositionskredite');
    const geschaeftsKredite = getValues('geschaeftskredite');
    const kontokorrentKredite = getValues('kontokorrentkredite');
    const kreditKarten = getValues('kreditkarten');
    const leasings = getValues('leasings');
    const ratenKredite = getValues('ratenkredite');
    const sonstigeVerbindlichkeiten = getValues('sonstigeVerbindlichkeiten');

    const dataSnippets = getValues('dataSnippets');

    return {
        conditions: {
            carFinance: getValues('carFinance'),
            commissionRequestInPercent: getValues('provision'),
            dataSnippets,
            financingPurpose: getValues('verwendungszweck'),
            liabilityStates: [
                ...dispositionsKredite,
                ...geschaeftsKredite,
                ...kontokorrentKredite,
                ...kreditKarten,
                ...leasings,
                ...ratenKredite,
                ...sonstigeVerbindlichkeiten,
            ].map((kredit) => ({
                abloesen: 'abloesen' in kredit ? kredit.abloesen : false,
                hide: kredit.hide,
                id: kredit.id,
            })),
            paymentDate: getValues('ratenzahlungstermin'),
            requestAmount: getValues('kreditBetrag'),
            residualDebtInsurance: getValues('restschuldversicherung'),
            runtimeInMonths: getValues('kreditLaufzeit'),
            totalFinancedAmount: getTotalFinancedAmount({
                coApplicantHidden,
                dataSnippets,
                dispositionsKredite,
                geschaeftsKredite,
                kreditKarten,
                ratenKredite,
                sonstigeVerbindlichkeiten,
            }),
        },
    };
};
